<template>
  <div>
    <el-dialog title="添加密钥" :visible.sync="visible" width="620px" top="5vh" :close-on-click-modal="false"  @open="openHandler" @closed="closedHandler">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="添加文件" name="1">
          <new-key @addSuccess="hide" />
        </el-tab-pane>

        <el-tab-pane label="粘贴文本" name="2">
          <new-key-from-text @addSuccess="hide" />
        </el-tab-pane>

        <el-tab-pane label="自动生成" name="3">
          <gen-key @addSuccess="hide" />
        </el-tab-pane>
      </el-tabs>

      <span slot="footer" class="dialog-footer">
        <el-button @click="() => {hide(); closedHandler()}" size="mini">返 回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import newKey from "./newKeyFromFile.vue"
import newKeyFromText from "./newKeyFromText.vue"
import genKey from "./genKey.vue"

export default {
  name: "addKey",
  components: {
    newKey,
    newKeyFromText,
    genKey,
  },
  data() {
    return {
      visible: false,
      activeTab: "1",
    }
  },
  methods: {
    show() {this.visible = true},
    hide() {this.visible = false},
    openHandler: function() {},
    closedHandler: function() {this.$emit('close')},
  },
}
</script>
